import CustomerScreenShell from "@/components/customer-screen-shell";
import Notice from "@buildpy/ui/notice";
import { Button } from "@buildpy/ui/button";

// 고객 링크(/c·/s)의 마지막 그물 — 오류 원문·digest 는 찍지 않고 고정 문구와 다시 시도만 준다.
const LinkError = ({ reset }: { reset: () => void }) => (
  <CustomerScreenShell>
    <Notice
      body="잠시 후 다시 시도해 주세요. 계속되면 문서를 보낸 시공사에 문의해 주세요."
      title="일시적인 문제로 문서를 열 수 없습니다">
      <Button className="mt-4 w-full" type="button" variant="primary" onClick={reset}>
        다시 시도
      </Button>
    </Notice>
  </CustomerScreenShell>
);

export default LinkError;
